// Web Vitals: LCP, INP, CLS, FCP, TTFB. Reported once each (after settled).
import { onLCP, onINP, onCLS, onFCP, onTTFB } from "web-vitals";

export function attachWebVitals(queue) {
  const url = location.pathname + location.search;
  const connection = (navigator.connection && navigator.connection.effectiveType) || null;

  const report = (entry) => {
    queue.pushVital({
      metric: entry.name,
      value: entry.value,
      rating: entry.rating,
      url,
      t: Date.now(),
      connection,
      attribution: serializeAttribution(entry.attribution),
    });
  };

  onLCP(report);
  onINP(report);
  onCLS(report);
  onFCP(report);
  onTTFB(report);
}

function serializeAttribution(attribution) {
  if (!attribution || typeof attribution !== "object") return null;
  // Keep payload small — only forward primitives.
  const out = {};
  for (const [k, v] of Object.entries(attribution)) {
    if (v === null) continue;
    const type = typeof v;
    if (type === "string" || type === "number" || type === "boolean") {
      out[k] = type === "string" ? v.slice(0, 256) : v;
    }
  }
  return Object.keys(out).length ? out : null;
}
